var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-sidebar',{attrs:{"shadow":"","z-index":"99999999","width":"100%"},on:{"hidden":_vm.onHide,"shown":_vm.onShown},model:{value:(_vm.sidebarOpened),callback:function ($$v) {_vm.sidebarOpened=$$v},expression:"sidebarOpened"}},[_vm._t("content")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }